<kendo-formfield>

    <div fxLayout="column" fxLayoutGap="5">


        <div fxLayout="row" fxLayoutGap="5" fxLayoutAlign="end end">


            <div fxLayout="column">
                <kendo-label [ngClass]="{'bold-caption-plus-minus':boldCaption}"
                    text="{{ caption | translate}}"></kendo-label>
                <div fxLayout="row"  fxLayoutGap="5">
                    <button kendoButton icon="minus" (click)="addToValue(-1 * settings.step)" type="button"> </button>
                    <kendo-numerictextbox [id]="formControlName" [ngClass]="{'plus-minus':true}"
                        [format]="settings.format" [formControl]="control" [step]="settings.step" [min]="settings.min"
                        [max]="settings.max" (valueChange)="onChange($event)" [spinners]="false">
                    </kendo-numerictextbox>
                    <button kendoButton icon="plus" (click)="addToValue(settings.step)" type="button"> </button>
                </div>

            </div>


        </div>
    </div>
</kendo-formfield>